/**
 * Trigger a browser download for a Blob.
 *
 * Lives here (not in trace-viewer) because trace-viewer's blob-returning
 * methods are environment-agnostic — only browser editors care about
 * filesystem downloads.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
